/* eslint-disable max-len */

import React from "react"

import BaseSvgIcon from "./Base"

const More = (props) => (
  <BaseSvgIcon {...props} viewBox="0 0 14 4">
    <g id="Home-Page-v2.0-JM" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="Homepage_default_VD_Desktop-Copy-12" transform="translate(-1113.000000, -858.000000)" fill="#D8D8D8" stroke="#3A3A38">
        <g id="Group-12" transform="translate(1114.000000, 859.000000)">
          <circle id="Oval-6" cx="1" cy="1" r="1" />
          <circle id="Oval-6-Copy" cx="6" cy="1" r="1" />
          <circle id="Oval-6-Copy-2" cx="11" cy="1" r="1" />
        </g>
      </g>
    </g>
  </BaseSvgIcon>
)

export default More
